/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chartperiodday2Inputs */

const en_chartperiodday2 = /** @type {(inputs: Chartperiodday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day`)
};

const de_chartperiodday2 = /** @type {(inputs: Chartperiodday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

/**
* | output |
* | --- |
* | "Day" |
*
* @param {Chartperiodday2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartperiodday2 = /** @type {((inputs?: Chartperiodday2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartperiodday2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartperiodday2(inputs)
	return de_chartperiodday2(inputs)
});
export { chartperiodday2 as "chartPeriodDay" }